<template>
  <div class="wrapper">
    <div class="wrapper_main" v-if="showPage">
      <!-- 送货申请  管理员 || 派送员 -->
      <!-- 待派单 -->
      <section class="deliver_apply" v-if="(come=='admin' && dispatchData.status == 0) || (come == 'staff' && dispatchData.status == 1)">
        <h4>新的送货申请</h4>
        <p>申请数量 {{dispatchData.deliveryNum}}</p>
        <p>申请时间 {{dispatchData.createTime | formatTime(11)}}</p>
        <p v-if="dispatchData.dispatchTime">派单时间 {{dispatchData.dispatchTime | formatTime(11)}}</p>
        <span>{{dispatchData.status == 0?'待派单':'待送货'}}</span>
      </section>
      <!-- 已派单,待送货上门 -->
      <section class="bill_list" v-if="(come=='admin' && dispatchData.status == 1) || (come && (dispatchData.status == 2) || (come && dispatchData.status == 3 || dispatchData.status == 4))">
        <section class="bill_item">
          <h3>送货单</h3>
          <p v-if="dispatchData.workerName">送货人:{{dispatchData.workerName}} <a :href="'tel:'+dispatchData.workerPhone" :phone="dispatchData.workerPhone">{{dispatchData.workerPhone}}</a></p>
          <p>申请送货数量: {{dispatchData.deliveryNum}}</p>
          <p>申请时间: {{dispatchData.createTime | formatTime(11)}}</p>
          <p v-if="dispatchData.dispatchTime">派单时间: {{dispatchData.dispatchTime | formatTime(11)}}</p>
          <p v-if="dispatchData.sendTime">送货时间: {{dispatchData.sendTime | formatTime(11)}}</p>
          <p class="status_wait" v-if="dispatchData.status == 1">已派单，待送货上门</p>
          <p class="status_wait" v-else-if="dispatchData.status == 2">送货完成，待确认收货</p>
          <img class="status_img" v-else-if="dispatchData.status == 3" src="../../assets/images/icon_canceled.png">
          <img class="status_img" v-else src="../../assets/images/icon_audit_completed.png">
          <span class="trigger"></span>
        </section>
      </section>
      <!-- 收货地址 -->
      <div class="orderCard" v-if="come">
        <p class="orderTitle">送货地址</p>
        <div class="orderNubBox">
          <span class="orderNubTitle">企业名称</span>
          <span class="orderNub">{{tenantOutput.company}}</span>
        </div>
        <div class="orderNubBox">
          <span class="orderNubTitle">企业地址</span>
          <span class="orderNub">{{tenantOutput.defaultBuild}}{{tenantOutput.defaultFloor}}</span>
        </div>
      </div>
      <!-- 办公耗材数据  @click="goActivityDetail(orderInfo.materialId)"-->
      <!-- 订单信息 -->
      <div class="orderCard">
        <p class="orderTitle">订单信息</p>
        <div class="click_item">
          <img class="click_image" :src="orderInfo.imgUrl">
          <div class="click_info">
            <p class="click_title">{{orderInfo.materialName}}</p>
            <p :class="['label_s',orderInfo.serviceType==0?'':'more_time']">{{orderInfo.serviceType | serviceType}}</p>
            <p class="click_num">x{{orderInfo.orderNum}}</p>
            <p class="click_price">¥{{orderInfo.price | priceFormat}}</p>
          </div>
        </div>
        <div class="orderNubBox">
          <span class="orderNubTitle">预订人</span>
          <span class="orderNub">{{orderInfo.createName}}</span>
        </div>
        <div class="orderNubBox">
          <span class="orderNubTitle">联系电话</span>
          <span class="orderNub">{{orderInfo.phone}}</span>
        </div>
        <div class="orderNubBox">
          <span class="orderNubTitle">订单编号</span>
          <span class="orderNub_c">{{orderInfo.orderNo}}</span>
          <span class="copy" @click="copyTradeCode" :data-clipboard-text="orderInfo.orderNo">复制</span>
        </div>
        <div class="orderNubBox">
          <span class="orderNubTitle">下单时间</span>
          <span class="orderNub">{{orderInfo.createTime}}</span>
        </div>
        <div class="orderNubBox" v-if="orderInfo.payTime && status == 2">
          <span class="orderNubTitle">支付时间</span>
          <span class="orderNub">{{orderInfo.payTime}}</span>
        </div>
          <div class="payAmountBox">
          <span class="label">{{status == 0 || status == 6?'应付:':'实付:'}}</span>
          <span class="payAmount">￥{{orderInfo.payAmount|returnFloat}}</span>
        </div>
      </div>
      <!-- 送货信息 送货员 -->
      <!-- <div class="orderCard" v-if="dispatchData.status == 1 && come == 'staff'">
        <p class="orderTitle">送货信息</p>
         <div class="orderNubBox">
          <span class="orderNubTitle">申请时间</span>
          <span class="orderNub">{{dispatchData.createTime | formatTime(11)}}</span>
        </div>
         <div class="orderNubBox">
          <span class="orderNubTitle">申请数量</span>
          <span class="orderNub">{{dispatchData.deliveryNum}}</span>
        </div>
        <div class="orderNubBox">
          <span class="orderNubTitle">企业名称</span>
          <span class="orderNub">{{common.userTenantInfo.company}}</span>
        </div>
        <div class="orderNubBox">
          <span class="orderNubTitle">企业地址</span>
          <span class="orderNub">{{common.userTenantInfo.defaultBuild}}{{common.userTenantInfo.defaultFloor}}</span>
        </div>
      </div> -->
      <!-- 企业微信管理员 派单 status==0-->
      <common-footer class="footer_box button" v-if="come=='admin' && dispatchData.status == 0">
        <mt-button class="btn btn_left btn_primary" v-if="orderInfo.serviceType!=0" @click="cancelSh">取消送货</mt-button>
        <mt-button :class="['btn','btn_right','btn_default',orderInfo.serviceType!=0?'':'onetime']" @click="dispatch">立即派单</mt-button>
      </common-footer>
      <!-- 企业微信管理员,送货员 status==1-->
      <common-footer class="footer_box button" v-if="come=='staff' && dispatchData.status == 1">
        <mt-button class="btn btn_left btn_primary" v-if="orderInfo.serviceType!=0" @click="cancelSh">取消送货</mt-button>
        <mt-button :class="['btn','btn_right','btn_default',orderInfo.serviceType!=0?'':'onetime']" @click="completeSh">送货完成</mt-button>
      </common-footer>
  </div>
  </div>
</template>

<script>
import util from '../../utils/util';
import commonFooter from "../../components/commonFooter";
import {getOfficeMaterialOrderDetailById,officeupdateOrderStatusWeChat, updateDelivery } from '../../utils/api';
import { mapState } from 'vuex';
import Clipboard from 'clipboard';
import ping from '../../utils/pingpay.js'
var timeout = '';
export default {
  name: 'myOfficeWxOrder',
  components:{
    commonFooter
  },
  data () {
    return {
      come:'',
      num:1,
      title: '活动表单',
      orderNo: '',
      status: '',
      showPage: false,
      orderInfo: {},
      deliveryList:[],//送货信息
      dispatchData:{},//具体某条派单信息
      activeReg: '',
      tenantOutput:{},//用户企业信息
      expiryTime: '',
      QRCode: '',
      isRefund: '',
      payAmount: '',
      canPay:true,
      id: ''
    };
  },
  filters: {
    serviceType(val){
      if(val == '0'){
        return '一次性送货'
      }else{
        return '多次送货服务'
      }
    },
    toTime: function (value) {
      return util.formatTime(new Date(value), 10);
    },
    statusText: function (value) {
      if(value == '0'){
        return '待支付'
      }else if(value == '1'){
        return '已取消'
      }else if(value == '2'){
        return '已支付'
      }else if(value == '5'){
        return '交易完成'
      }else if(value == '6'){
        return '已退订'
      }else{
        return '未定义'
      }
    },
    statusPrompt: function (value) {
      if (value === 1) {
        return '取消原因：用户主动取消';
      } else if (value === 2) {
        return '支付成功，请在活动限期内使用';
      } else if (value === 3) {
        return '取消原因：超时取消';
      } else {
        return '感谢您的参与';
      }
    }
  },
  computed: {
    ...mapState({
      common: state => state.common
    }),
    statusImg(){
      if(this.status == '0'){
        return require('../../assets/images/icon_order_unpaid.png')
      }else if(this.status == '2'){
        return require('../../assets/images/icon_order_complete.png')
      }else{
        return require('../../assets/images/icon_order_cancel.png')
      }
    },
  },
  unmounted () {
    clearTimeout(timeout);
  },
  created () {
    console.log()
    this.come = this.$route.query.come || ''
  },
  activated () {
    this.id = this.$route.query.id
    this.getOfficeMaterialOrderDetailById()
  },
  methods: {
    getOfficeMaterialOrderDetailById(){
      util.showLoading()
      getOfficeMaterialOrderDetailById({orderId: this.$route.query.id}).then(res => {
        console.log(res)
        util.hideLoading()
        if (res.res && res.res.code === 10000 && res.body) {
          this.orderInfo = res.body.order || {};
          this.status = res.body.order.status;
          this.deliveryList = res.body.deliveryList || [];
          this.tenantOutput = res.body.tenantOutput || {};
          let date = util.formatTime(new Date(res.body.order.lastPayTime - Date.parse(new Date())), 3)
          if (this.status === 0) {
            this.leftTimer(date)
          }
          // 送货单
          let dispatchId = this.$route.query.dispatchId
          if(dispatchId){
            this.deliveryList.forEach(item=>{
              if(item.id == dispatchId){
                this.dispatchData = item
              }
            })
          }
        } else {
          util.showToast(res.res.msg);
        }
        this.showPage = true;
      })
    },
    dispatch(){
      this.$router.push(`/officeDispatch?id=${this.$route.query.dispatchId}&orderId=${this.orderInfo.id}&marketid=${this.orderInfo.marketId}&cityId=${this.orderInfo.cityId}`)
    },
    viewEvaluation () {
      this.$router.push(`/evaluate/viewEvaluate?id=${this.orderInfo.id}`)
    },
    evaluate () {
      this.$router.push(`/evaluate/evaluate?id=${this.orderInfo.id}&referenceName=${this.orderInfo.actTitle}&templateType=1&referenceNo=${this.orderInfo.orderNo}`)
    },
    goActivityDetail (id) {
      this.$router.push({
        path:`/officeServiceDetail?id=${id}`
      })
    },
    // 复制成功
    copyTradeCode () {
      var clipboard = new Clipboard('.copy')
      clipboard.on('success', () => {
        util.showToast('复制成功')
          // 释放内存
        clipboard.destroy()
      })
    },
    // 立即支付
    goPayCenter () {
      if(!this.canPay){return;}
      this.canPay = false;
      let params = {
        orderNo: this.orderInfo.orderNo,
        repairNo: '', // "报修单号",
        bussinessType:"6",//会议室1,活动2,租赁账单3,物业报修4,保洁服务5,送水服务6
        feeCode:"",
        // payType: '5', // "支付类型 0微信，1支付宝, 4万生活, 5,ping++"
        channel: 'wx_pub' // 渠道名
      };
      ping(params,'',res => {
          console.log(res);
          this.canPay = true;
          this.getOfficeMaterialOrderDetailById()
        },
        () => {
          this.canPay = true;
          this.getOfficeMaterialOrderDetailById()
        },
        () => {
          this.canPay = true;
          this.getOfficeMaterialOrderDetailById()
        }
      );
      setTimeout(()=>{this.canPay = true;},1000)
    },
    // 倒计时
    leftTimer (leftTime) {
      clearTimeout(timeout)
      var minutes = parseInt(leftTime / 60 % 60, 10); // 计算剩余的分钟
      var seconds = parseInt(leftTime % 60, 10); // 计算剩余的秒数
      var myTime = leftTime
      minutes = minutes >= 10 ? minutes:'0'+minutes;
      seconds = seconds >= 10 ? seconds:'0'+seconds;
      if (myTime >= 0) {
        this.expiryTime = minutes + '分' + seconds + '秒';
        myTime = myTime - 1
        timeout = setTimeout(() => {
          this.leftTimer(myTime)
        }, 1000)
      }else{
        this.getOfficeMaterialOrderDetailById()
      }
    },
    // 取消订单
    cancelOrderByOrderId () {
      util.showModal('', '确定要取消该订单吗？', true, '确定', () => {
        officeupdateOrderStatusWeChat({
          orderId: this.orderInfo.id,
          status: '1',//0待支付，1已取消，2已支付
          approve:this.common.userInfo.account || this.common.userInfo.phone
        }).then(res => {
          console.log(res)
          if (res.res.code === 10000) {
            this.getOfficeMaterialOrderDetailById()
          }
        })
      })
    },
    cancelSh(){
      // 0待送货 1送货中 2送货完成 3取消送货 4确认收货
      util.showModal('',`确定要取消送货吗?`,true,'确定',()=>{
        let params = {
          deliveryId:this.$route.query.dispatchId,
          orderId:this.orderInfo.id,
          status:'3'
        }
        let header = {}
        if(this.$route.query.marketId){
          header.marketId = this.$route.query.marketid
        }
        if(this.$route.query.cityId){
          header.cityId = this.$route.query.cityId
        }
        util.showLoading()
        updateDelivery(params,header).then(res=>{
          console.log(res)
          util.hideLoading()
          if(res.res.code === 10000){
            util.showToast('已取消')
            this.getOfficeMaterialOrderDetailById()
          }else{
            util.showToast(res.res.msg)
          }
        })
      })
    },
    completeSh(){
      // 0待送货 1送货中 2送货完成 3取消送货 4确认收货
      util.showModal('',`确定送货完成吗?`,true,'确定',()=>{
        let params = {
          deliveryId:this.$route.query.dispatchId,
          orderId:this.orderInfo.id,
          status:'2'
        }
        let header = {}
        if(this.$route.query.marketId){
          header.marketId = this.$route.query.marketid
        }
        if(this.$route.query.cityId){
          header.cityId = this.$route.query.cityId
        }
        util.showLoading()
        updateDelivery(params,header).then(res=>{
          console.log(res)
          util.hideLoading()
          if(res.res.code === 10000){
            util.showToast('操作成功')
            this.getOfficeMaterialOrderDetailById()
          }else{
            util.showToast(res.res.msg)
          }
        })
      })
    }
  }
};
</script>
<style lang="less" scoped>
@import "../../assets/css/common.less";
.wrapper {
    background-color: rgba(243, 244, 246, 1);
  }
  .wrapper_main{
    margin-bottom:120px;
  }
  .headerBox {
    height: 150px;
    background:linear-gradient(90deg,rgba(23,64,218,1) 0%,rgba(101,0,255,1) 100%);
    .flex();
    justify-content: space-between;
    align-items: center;
    padding:0 28px;
    position: relative;
    .order_img{
      position:absolute;
      right:66px;bottom:32px;width:86px;
      height:84px;
      z-index:2;
    }
  }
  .cardLeft {
    .flex(column);
    justify-content: space-between;
    align-items: flex-start;
    height: 96px;
  }

  .clockBox {
    .flex();
    align-items: center;
    height: 36px;
  }

  .clockIcon {
    width: 36px;
    height: 36px;
    margin-right: 14px;
  }

  .clockText {
    .fontSize(14px);
    font-weight: bold;
    color: #fff;
  }

  .statusText {
    height: 36px;
    background-color: rgba(0, 0, 0, 0.1);
    border-radius: 8px;
    .fontSize(11px);
    color: rgba(255, 255, 255, 1);
    line-height: 36px;
    text-align: center;
    padding: 0 14px;
  }
  /*item 样式*/
  .click_item{
    .flex();
    padding: 28px;
    opacity: 1;
    background-color: #ffffff;
    margin-bottom:14px;
    .borderB();
    .borderT();
  }
  .click_item:active{
    // opacity: 0.7;
  }
  .click_desc{
    .fontSize(12px);
    color:@color6;
    line-height:34px;
    margin-bottom: 8px;
  }
  .click_image{
    display: block;
    width: 240px;
    height: 180px;
    margin-right: 20px;
  }
  .click_info{
    flex:1;
  }
  .click_title{
    height:40px;
    .fontSize(14px);
    font-weight:bold;
    color:rgba(51,51,51,1);
    line-height:40px;
    .textOver(100%);
    margin-bottom: 20px;
  }
  .click_label{
    line-height:36px;
    background:rgba(255,240,225,1);
    border-radius:4px;
    font-size:24px;
    color:rgba(255,126,30,1);
    display: inline-block;
    padding:0 6px;
  }
  .label_s{
    padding:0 6px;
    height:36px;
    background:rgba(255,240,225,1);
    border-radius:4px;
    font-size:24px;
    margin-bottom:10px;
    color:rgba(255,126,30,1);
    line-height:36px;
    display: inline-block;
  }
  .more_time{
    background:#def5ed;
    color:#16bc84;
  }
  .click_num{
    font-size:26px;
    color:rgba(153,153,153,1);
    line-height:36px;
    text-align: right;
    margin-bottom:4px;
  }
  .click_price{
    font-size:28px;
    color:rgba(51,51,51,1);
    line-height:40px;
    text-align: right;
  }
  /*-----------中间卡片信息模块------*/

  .card_box {
    position: relative;
    width: 690px;
    margin-left: 30px;
    margin-top: 26px;
  }

  .card_title {
    .fontSize(14px);
    font-weight: bold;
    color: rgba(254, 254, 254, 1);
    line-height: 36px;
    position: absolute;
    left: 28px;
    top: 30px;
    right: 28px;
  }

  .pay_time {
    .fontSize(12px);
    color: rgba(254, 254, 254, 1);
  }

  .card_address {
    .fontSize(12px);
    color: rgba(254, 254, 254, 1);
    position: absolute;
    left: 28px;
    top: 116px;
    right: 28px;
  }

  .card_price_box {
    flex-direction: row;
    position: absolute;
    left: 28px;
    right: 28px;
    bottom: 124px;
  }

  .card_price {
    color: #FFF;
    .fontSize(18px);
    line-height: 36px;
  }

  .card_num {
    color: #FFF;
    .fontSize(12px);
    line-height: 36px;
    margin-top: 4px;
  }

  .card_time_box {
    flex-direction: row;
    justify-content: space-between;
    position: absolute;
    height: 102px;
    align-items: center;
    left: 28px;
    right: 28px;
    bottom: 0;
  }

  .activity_time {
    color: #FFF;
    .fontSize(12px);
  }

  /*----------中间用户信息模块-------*/
  .refundBox {
    background-color: rgba(255, 255, 255, 1);
    padding: 28px;
  }

  .refundText {
    height:44px;
    .fontSize(16px);
    font-weight: bold;
    color: rgba(51, 51, 51, 1);
    line-height: 44px;
    margin-bottom: 20px;
    padding-left: 18px;
    position: relative;
    &::after{
      position: absolute;
      content:'';
      left:0;top:4px;
      width:6px;
      height:24px;
      background:@color17;
    }
  }

  .refundMainBox {
    .flex();
    margin-top: 18px;
    width:710px;
  }

  .refundMainLeft {
    width: 72px;
    .flex(column);
    justify-content: space-around;
    align-items: center;
  }

  .refundMainRight {
    flex: 1;
    height:34px;
    .flex(column);
    justify-content: space-between;
  }
  .refundMainRight_upt{
    height:128px;
  }
  .refundMainRight_succ{
    height:220px;
  }

  .refundMainText {
    .fontSize(12px);
    /*color: rgba(51, 51, 51, 1);*/
    line-height: 34px;
  }
  .refund_active{
    color: #333333;
  }
  .refund_default{
    color: #DADADA;
  }

  .circle {
    width: 20px;
    height: 20px;
    background-color: @color17;
    border: 4px solid rgba(255, 255, 255, 1);
    border-radius: 100%;
    // margin: 7px 0;
  }

  .upright {
    width: 4px;
    height: 60px;
    /*background-color: @color17;*/
  }
  .active_color {
    background-color: @color17;
  }
  .default_color {
    background-color: #DADADA;
  }

  /*----------中间用户信息模块-------*/

  .copy {
    width: 96px;
    height: 40px;
    border-radius: 8px;
    .border();
    .fontSize(12px);
    color: @color3;
    line-height: 40px;
    text-align: center;
    margin-left: 28px;
  }

  .mainCard {
    width: 100%;
    background-color: rgba(255, 255, 255, 1);
    /*box-shadow: 0px 4px 8px 0px rgba(0, 0, 0, 0.02);*/
    /*border-radius: 16px;*/
    margin-bottom: 14px;
  }

 .QRCodeCard {
    .flex(column);
    align-items: center;
    width: 100%;
  }
  .QRCodeTitle {
    .fontSize(14px);
    color: rgba(51, 51, 51, 1);
    line-height: 40px;
    margin-top: 40px;
  }

  .QRCode {
    width: 260px;
    height: 260px;
    /*margin: 20px 0;*/
  }

  .QRCodeOrderNo {
    .fontSize(14px);
    color: rgba(51, 51, 51, 1);
    line-height: 40px;
    margin-bottom: 40px;
  }

  .orderCard {
    padding: 28px 28px 14px;
    margin: 14px 0;
    background-color: #ffffff;
    position: relative;
    .orderNubBox {
      min-height: 40px;
      margin-bottom: 14px;
      .flex();
    }
  }

  .createTimeBox {
    border-top-width: 2px;
    border-top-color: rgba(234, 234, 234, 1);
    padding: 0 20px 28px;
  }

  .orderTitle {
    height: 44px;
    .fontSize(16px);
    font-weight: bold;
    color: @color3;
    line-height:44px;
    margin-bottom: 20px;
    padding-left: 18px;
    position: relative;
    &:after{
      position:absolute;
      left:0;top:10px;
      width:6px;height:24px;
      background:@color17;
      content:'';
    }
  }


  .orderNubTitle {
    .fontSize(12px);
    color: @color6;
    line-height:34px;
    width: 150px;
  }

  .orderNub {
    .fontSize(12px);
    color: @color3;
    line-height:34px;
    width:500px;
  }
  .orderNub_c{
    .fontSize(12px);
    color: rgba(51, 51, 51, 1);
    line-height:40px;
  }

  .customer_box {
    padding-top: 20px;
    border-bottom-width: 10px;
    border-bottom-color: #F3F4F6;
  }

  .customer_box_list {
    flex-direction: row;
    justify-content: space-between;
    border-top-width: 1px;
    border-top-color: #F3F4F6;
    padding-left: 30px;
    padding-right: 30px;
  }

  .list_key {
    height: 100px;
    line-height: 100px;
    .fontSize(14px);
    color: #999;
  }

  .list_val {
    height: 100px;
    line-height: 100px;
    .fontSize(14px);
    color: #333;
  }

  /*----------中间支付选择模块-------*/


  .butn_img {
    position: relative;
    top: -1px;
    left: -1px;
  }

  .payAmountBox {
    position:absolute;
    top:34px;right:28px;
    .flex();
    align-items: center;
    justify-content: flex-end;
    .label {
      .fontSize(13px);
      color: rgba(51, 51, 51, 1);
    }
    .payAmount {
      .fontSize(16px);
      color: rgba(252, 63, 86, 1);
    }
  }


  /*-----------底部模块----------*/

  .btnBox {
    height: 108px;
    position:fixed;
    bottom:0;left:0;right:0;
    z-index:33;
    .borderT();
    background-color: #fff;
    .flex();
    align-items: center;
    justify-content: flex-end;
  }

  .cancel {
  width: 128px;
  height: 52px;
  border-radius: 4px;
  .border(#dadada);
  .fontSize(13px);
  color: #666666;
  line-height: 54px;
  text-align: center;
  margin-right: 28px;
  display:block;
}

.btn {
  width: 128px;
  height: 52px;
  border-radius:4px;
  .border(@color17);
  .fontSize(13px);
  color:@color17;
  // line-height: 52px;
  display: flex;
  align-items:center;
  justify-content:center;
  box-sizing: border-box;
  text-align: center;
  margin-right: 28px;
  background:rgba(243,245,253,1);
  // display:block;
}
// 待线下确认
.wait_height{
  height:100px;
}
.wait_cost{
  position: fixed;
  z-index:34;
  bottom:107px;
  height:100px;
  left:0;right:0;
  background:#fff2e8;
  .flex(column);
  align-items: center;
  justify-content: center;
  p{
    font-size:28px;
    color:rgba(51,51,51,1);
    line-height:40px;
    &.desc{
      color:#999;
      font-size:24px;
    }
  }
}
// 申请送货
.paid_height{
  height:90px;
}
.paid_box{
  position: fixed;
  bottom:0;left:0;right:0;
  z-index:10;
  background:#E7F8F2;
  .paid_box_top{
    .flex();
    height:88px;
    align-items: center;
    justify-content: center;
    p{
      flex:1;
      text-align: center;
      font-size:28px;
      color:rgba(102,102,102,1);
    }
    .buy_num{
      span{
        font-size:36px;
        color:#333;
        font-weight: bold;
      }
    }
    .last_num{
      span{
        font-size:36px;
        color:#FF7E1E;
        font-weight: bold;
      }
    }
  }
  .apply_btn{
    margin:16px 32px;
    height:76px;
    line-height: 76px;
    background:rgba(22,188,132,1);
    border-radius:4px;
    font-size:32px;
    color:rgba(255,255,255,1);
    text-align: center;
  }
}
// 送货单
.bill_item{
  position: relative;
  background:#fff;
  margin-bottom:14px;
  padding:28px 28px 18px;
  overflow: hidden;
  h3{
    font-size:32px;
    font-weight:bold;
    color:rgba(51,51,51,1);
    line-height:44px;
    margin-bottom:20px;
  }
  p{
    font-size:26px;
    color:rgba(102,102,102,1);
    line-height:36px;
    margin-bottom:10px;
    a{
      color:#1740da;
      font-size:26px;
      display: inline-block;
      margin-left:40px;
    }
  }
  .bill_btn{
    width:128px;
    height:52px;
    border-radius:4px;
    border:2px solid rgba(22,188,132,1);
    text-align: center;
    line-height:52px;
    box-sizing: border-box;
    font-size:26px;
    color:rgba(22,188,132,1);
    display:block;
    position:absolute;
    bottom:28px;right:28px;
  }
  .status_wait{
    position:absolute;
    top:28px;right:28px;
    font-size:24px;
    color:rgba(22,188,132,1);
    line-height:34px;
  }
  .status_img{
    position:absolute;
    top:28px;right:28px;
    width:120px;height:120px;
    display:block;
  }
  .bill_img{
    width:120px;
    height:120px;
    display: block;
    top:28px;
    right:28px;
    position:absolute;
  }
  .trigger{
    position: absolute;
    left:-18px;top:-18px;
    width:36px;
    height:36px;
    z-index:2;
    transform:rotate(45deg);
    background:#16bc84;
  }
}
.bill_more{
  margin:20px;
  height:76px;
  background:rgba(255,255,255,1);
  border-radius:8px;
  text-align:center;
  line-height: 76px;
  font-size:28px;
  color:rgba(51,51,51,1);
}
// 送货申请 弹框
.apply_box{
  background:#fff;
  position: relative;
  h2{
    text-align: center;
    font-size:36px;
    font-weight:bold;
    color:rgba(51,51,51,1);
    line-height:50px;
    padding:40px 0;
  }
  .num_main{
    .flex();
    justify-content: center;
    margin-bottom:62px;
    .line{
      width:2px;
      height:34px;
      background:#eaeaea;
      display:block;
      margin:0 40px;
    }
    p{
      color:#666;
      font-size:28px;
    }
    .buy_num{
      span{
        color:#333;
      }
    }
    .last_num{
      span{
        color:#fd9838;
      }
    }
  }
  .number{
    font-size:28px;
    color:rgba(51,51,51,1);
    line-height:40px;
    margin-bottom:28px;
    text-align:center;
  }
  .input_box{
      .flex();
      justify-content: center;
      margin-bottom:52px;
      .reduce{
        display: block;
        width:80px;
        height:80px;
        background:rgba(238,238,238,0.3);
        border-radius:4px;
        .flex();
        justify-content: center;
        align-items: center;
        border:2px solid #eaeaea;
        img{
          display: block;
          width:24px;
          height:4px;
        }
      }
      input{
        display: block;
        width:200px;
        height:80px;
        background:#f8f8f8;
        margin:0 20px;
        font-size:28px;
        color:rgba(51,51,51,1);
        text-align: center;
        border:2px solid #eaeaea;
      }
      .add{
        display: block;
        width:80px;
        height:80px;
        background:rgba(238,238,238,1);
        border:2px solid #eaeaea;
        border-radius:4px;
        .flex();
        justify-content: center;
        align-items: center;
        img{
          display: block;
          width:24px;
          height:24px;
        }
      }
    }
    .close{
      display: block;
      width:44px;
      height:44px;
      position: absolute;
      right:20px;top:20px;
    }
    .submit_btnn{
      margin:28px;
      height:76px;
      background:rgba(22,188,132,1);
      border-radius:4px;
      font-size:32px;
      color:rgba(255,255,255,1);
      line-height:76px;
      text-align:center;
    }
}
// 送货申请
.deliver_apply{
  border-left:8px solid #16bc84;
  background:#F5FFFB;
  position:relative;
  padding:0 28px 8px;
  margin-bottom:14px;
  h4{
    font-size:32px;
    font-weight:bold;
    color:rgba(51,51,51,1);
    line-height:44px;
    padding:28px 0;
  }
  p{
    font-size:26px;
    color:rgba(51,51,51,1);
    line-height:36px;
    margin-bottom:20px;
  }
  span{
    position: absolute;
    top:28px;right:28px;
    color:#16bc84;
    font-size:26px;
  }
}
.footer_box {
  .btn {
    width: 332px;
    height: 68px;
    border-radius: 4px;
    line-height:68px;
    box-sizing: border-box;
    text-align:center;
    font-size:28px;
    margin:0 10px;
  }
  .btn_left{
    .border(rgba(150, 170, 240, 1));
    background: rgba(243, 245, 253, 1);
    color:@color17;
  }
  .btn_right{
    border:0;
    box-shadow: 0 0 0 #fff;
    background: @color17;
    color:#fff;
  }
  .onetime{
    width:100%;
    margin:0;
  }
  .btn_w{
    width:100%;
  }
  .btn_unclick{
    background:rgba(218,218,218,1);
    color:#fff;
  }
}
</style>
